export const SEARCH_TRACE_ALLOWED_EMAIL = "development@methodandmotion.ai";
